import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const SegmentedControlClassName = `${CLASS_NAME_PREFIX}-segmented-control`;
export const SegmentedControlSegmentValueClassName = `${SegmentedControlClassName}-value-`;
export const SegmentedControlSegmentsContainerClassName = `${SegmentedControlClassName}__segments-container`;
export const SegmentedControlSegmentClassName = `${SegmentedControlSegmentsContainerClassName}-segment`;
export const SegmentedControlSegmentTextClassName = `${SegmentedControlSegmentClassName}-text`;
export const SegmentedControlSegmentStartIconClassName = `${SegmentedControlSegmentClassName}-start-icon`;
export const SegmentedControlSegmentEndIconClassName = `${SegmentedControlSegmentClassName}-end-icon`;
